import { useState } from "react";
import { SuccessStory } from "./SuccessStoriesSpeakForThemselves";
import "./SuccessStoryCard.css";
import PillButton from "../PillButton";
import { useNavigate } from "react-router/dist";
import imageFallBack from "../../../images/MAM_Logo_-_2.png";
interface SuccessStoryProps {
  story: SuccessStory;
}

const SuccessStoryCard: React.FC<SuccessStoryProps> = ({ story }) => {
  return (
    <div className="card shadow-sm rounded-3 overflow-hidden h-100 success-story-card">
      {/* Image */}
      <img
        src={story.imageURL || imageFallBack}
        alt={story.briefHeader}
        className="card-img-top img-fluid"
        style={{ objectFit: "contain", maxHeight: "200px" }}
      />
      {/* Text */}
      <div className="card-body d-flex flex-column">
        <p className="text-muted small mb-1">{story.coordinatorName}</p>
        <h5 className="card-title fw-semibold">{story.briefHeader}</h5>
        <p
          className="card-text text-secondary small flex-grow-1 overflow-auto"
          style={{ maxHeight: "100px" }}
        >
          {story.detailedDescription}
        </p>

        {/* Stats */}
        <div className="row text-center mt-3">
          <div className="col">
            <p className="fw-bold mb-0">{story.totalRaised}</p>
            <small className="text-muted">total raised</small>
          </div>
          <div className="col">
            <p className="fw-bold mb-0">{story.campaignDuration}</p>
            <small className="text-muted">campaign duration</small>
          </div>
          <div className="col">
            <p className="fw-bold mb-0">{story.totalSupporters}</p>
            <small className="text-muted">total supporters</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export const StartOwnSuccessStory = () => {
  const navigate = useNavigate();
  return (
    <div className="card shadow-sm rounded-3 overflow-hidden h-100 success-story-card start-own-success-story-container">
      <div className="card-body d-flex justify-content-center align-items-center text-center">
        <div>
          <h2 className="start-own-success-story-heading mb-3">
            Ready to start your own
            <br />
            Success Story?
          </h2>
          <p className="text-secondary small mb-3">
            Join hundreds of teams who've already <br /> made it happen - it's
            your turn!
          </p>
          <PillButton
            label="Get Started Now"
            onClick={() => navigate("/new-fundraiser-request")}
          />
        </div>
      </div>
    </div>
  );
};

export default SuccessStoryCard;
